import styled from 'styled-components';

export const FormWrapper = styled.div`
  margin-bottom: 4rem;
  .select__menu {
    z-index: 2;
  }
`;
